<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";

/**
 * Invoice-detail component
 */
export default {
  page: {
    title: "Payment Receipt",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      current_data: moment(new Date()).format("DD-MM-YYYY"),
      id: atob(this.$route.params.id),
    };
  },
  computed: {
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("insurance", ["Paymentsinsreciept", "InsuranceInvoiceStatus"]),
  },
  watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        if (this.notificationtype == "success") {
          this.$toast.success(this.notification_message.msg);
        } else {
          this.submitted = false;
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchPaymentsinsreciept: "insurance/fetchInsurancePaymentsReceipt",
    }),
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
  },
  updated() {
    setTimeout(() => {
      window.print();
    }, 2000);
  },
  created() {
    this.FetchPaymentsinsreciept(this.id);
  },
};
</script>
<style scoped>
.print-font {
  font-family: "Lucida Console", "Courier New", monospace;
}
</style>
<template>
  <Layout>
    <div class="row">
      <div class="col-lg-12">
        <div class="d-print-none">
          <Toasts
            :show-progress="true"
            :rtl="true"
            :max-messages="20"
            :time-out="3000"
            :closeable="false"
            :solid="true"
          ></Toasts>
          <div class="float-end">
            <a
              href="javascript:window.print()"
              class="btn btn-primary waves-effect waves-light me-1"
              ><i class="fa fa-print"></i> Print Receipt</a
            >
          </div>
        </div>
        <div class="d-print-none">
          <button @click="$router.go(-1)" class="btn btn-success mb-2">
            <i class="fas fa-arrow-circle-left"></i> Go Back
          </button>
        </div>

        <div class="bg-white p-2">
          <div class="print-font">
            <center>
              <b-spinner
                v-if="InsuranceInvoiceStatus"
                class="m-0"
                variant="primary"
                role="status"
              ></b-spinner>
              <img
                v-else
                :src="
                  Paymentsinsreciept.clinic_logo ? Paymentsinsreciept.clinic_logo : '--'
                "
                alt="Logo"
                height="70"
              />
              <br />
              <strong>
                {{
                  Paymentsinsreciept.clinic_name ? Paymentsinsreciept.clinic_name : "---"
                }}</strong
              >
              <p>
                <span>
                  {{
                    Paymentsinsreciept.clinic_location
                      ? Paymentsinsreciept.clinic_location
                      : "---"
                  }}</span
                >
                <br />
                {{
                  Paymentsinsreciept.clinic_contact
                    ? "+256" + Paymentsinsreciept.clinic_contact
                    : "---"
                }}
                <br />
                {{
                  Paymentsinsreciept.clinic_email
                    ? Paymentsinsreciept.clinic_email
                    : "---"
                }}
              </p>
              <h5>INSURANCE PAYMENT RECEIPT</h5>
            </center>
            <hr style="border-style: dashed; width: 97%" />
            <center>
              <table width="100%">
                <tr>
                  <td><b>Date</b></td>
                  <td>{{ current_data }}</td>
                </tr>
                <tr>
                  <td><b>Name</b></td>
                  <td>
                    {{
                      Paymentsinsreciept.insurance_name
                        ? Paymentsinsreciept.insurance_name
                        : "---"
                    }}
                  </td>
                </tr>
                <tr>
                  <td><b>Contact</b></td>
                  <td>
                    {{
                      Paymentsinsreciept.insurance_contact
                        ? Paymentsinsreciept.insurance_contact
                        : "---"
                    }}
                  </td>
                </tr>
                <tr>
                  <td><b>Invoice</b></td>
                  <td>
                    {{
                      Paymentsinsreciept.invoice_no
                        ? Paymentsinsreciept.invoice_no
                        : "---"
                    }}
                  </td>
                </tr>

                <tr>
                  <td><b>Reciept</b></td>
                  <td>
                    {{
                      Paymentsinsreciept.reciept_no ? Paymentsinsreciept.reciept_no : "--"
                    }}
                  </td>
                </tr>
              </table>
            </center>
            <hr />

            <br />
            <div style="width: 100%">
              <b
                >Recieved:{{
                  this.thousandSeprator(
                    Paymentsinsreciept.recieved ? Paymentsinsreciept.recieved : "--"
                  )
                }}/=</b
              >
              <p>
                <b>Total:</b>
                {{
                  this.thousandSeprator(
                    Paymentsinsreciept.total ? Paymentsinsreciept.total : "0"
                  )
                }}/=
                <br />
                <b>Paid:</b>
                {{
                  this.thousandSeprator(
                    Paymentsinsreciept.paid ? Paymentsinsreciept.paid : "0"
                  )
                }}/=
                <br />

                <b>Balance:</b>
                {{
                  this.thousandSeprator(
                    Paymentsinsreciept.balance ? Paymentsinsreciept.balance : "0"
                  )
                }}/=
              </p>
            </div>
            <center>
              <hr style="border-style: dashed; width: 97%" />
              <p>
                Signature ..........................................
                <br />Thank you for trusting
                <strong>
                  {{
                    Paymentsinsreciept.clinic_name
                      ? Paymentsinsreciept.clinic_name
                      : "---"
                  }}</strong
                >
                <br />For more inquiries call
                <strong>{{
                  Paymentsinsreciept.clinic_contact
                    ? Paymentsinsreciept.clinic_contact
                    : "---"
                }}</strong>
              </p>
              <p>
                Receipt Printed by
                {{ Paymentsinsreciept.printuser ? Paymentsinsreciept.printuser : "--" }}
                via Clinic Plus Hospital Software
              </p>
            </center>
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
    <!-- end row -->
  </Layout>
</template>
